<template>
  <div v-if="error.length" class="error">
    Please correct the following errors:
    <ul>
      <li v-for="(err, index) in error" :key="index">{{ err }}</li>
    </ul>
  </div>

  <div class="cell small-12">
    <h1>Do You Act as a Subcontractor Under CIS?</h1>
    <p>Under the Construction Industry Scheme (CIS), companies working in construction may be treated as subcontractors when they carry out work for other contractors.</p>
    <p>If you’re paid by another business for construction work, they might make deductions from your payments and pass them to HMRC — these are called CIS deductions suffered.</p>
    <p>If that applies to you, we’ll need to report those deductions so they can be offset against your tax bill.</p>
    <p>Do you act as a subcontractor and have CIS deductions suffered that need to be submitted to HMRC?</p>

    <div class="cell small-6">
      <form class="fieldset" @submit.prevent>
            <label class="radio-label custom-check"><input type="radio" :value=true v-model="formData.companyIsContractor">Yes we act as a subcontractor and have CIS deductions that we need to report<span class="radiomark"></span></label>
            <label class="radio-label custom-check"><input type="radio" :value=false v-model="formData.companyIsContractor">No we do not act as a subcontractor or do not need to report CIS deductions suffered<span class="radiomark"></span></label>
      </form>
    </div>

  </div>


</template>


<script setup>

import { ref, onMounted } from 'vue'

const error = ref([]);

const props = defineProps({
  formData: Object
})


const validateStep = () => {

  error.value = [];

  if (props.formData.companyIsContractor === undefined || props.formData.companyIsContractor === null || props.formData.companyIsContractor === '') {
    error.value.push('Please select an option.');
  }


  if (error.value.length > 0) return false;


  return true;
}



const executeStep = async () => {
  return true;
}



onMounted(() => {

});

defineExpose({ validateStep, executeStep });

</script>